import React, { FC, ReactNode } from 'react';
import styles from './privacy-policy.module.css';
import { useSearchParams } from 'react-router-dom';
interface PrivacyPolicyProps {
  children?: ReactNode;
}

export const PrivacyPolicy: FC<PrivacyPolicyProps> = ({ children }) => {
  const [searchParams] = useSearchParams();
  let isHotel = searchParams.get('hotel');

  return (
    <div className="text-left inline-flex flex-col items-start gap-[32px] relative">
      <div className="flex-col max-w-[1036px] items-start gap-[16px] flex relative flex-[0_0_auto]">
        <div className="relative w-fit mt-[-1.00px] font-20-h2 font-[number:var(--20-h2-font-weight)] text-primaryprimary text-[length:var(--20-h2-font-size)] tracking-[var(--20-h2-letter-spacing)] leading-[var(--20-h2-line-height)] whitespace-nowrap [font-style:var(--20-h2-font-style)]">
          政策簡介
        </div>
        <img
          className="relative self-stretch w-full h-px object-cover"
          alt="Vector"
          src="/assets/images/privacy/vector-19-1.svg"
        />
        <div className="flex flex-col items-start gap-[8px]">
          <p className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
            <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
              歡迎來到
            </span>
            <a
              href="https://www.ohyagroup.com"
              rel="noopener noreferrer"
              target="_blank"
            >
              <span className="[font-family:'Noto_Sans_TC-Medium',Helvetica] font-bold underline">
                歐悅集團官方網站
              </span>
            </a>
            <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
              ，以下稱本網站！
              <br />
            </span>
          </p>
          <p className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
            <span className="[font-family:'Noto_Sans_TC-Medium',Helvetica] font-bold">
              歐悅國際股份有限公司 (以下簡稱本公司) 及其關係企業
            </span>
            <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
              {' '}
              係依照
            </span>
            <a
              href="https://law.moj.gov.tw/LawClass/LawAll.aspx?PCode=I0050021"
              rel="noopener noreferrer"
              target="_blank"
            >
              <span className="[font-family:'Noto_Sans_TC-Medium',Helvetica] font-bold underline">
                中華民國「個人資料保護法」
              </span>
            </a>
            <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
              及其他相關法令規定，蒐集、處理及利用您的個人資料，保護您個人的隱私權。為了讓您能夠更安心地使用本公司及其關係企業所提供的各項服務，並透明化本公司及其關係企業如何蒐集、應用及保護您所提供的個人資料。
              <br />
            </span>
          </p>
          <p className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
            <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
              最後變更日期：2024-02-26
            </span>
          </p>
        </div>
      </div>
      <div className="flex-col max-w-[1036px] items-start gap-[16px] flex relative flex-[0_0_auto]">
        <div className="w-fit mt-[-1.00px] font-20-h2 font-[number:var(--20-h2-font-weight)] text-primaryprimary text-[length:var(--20-h2-font-size)] leading-[var(--20-h2-line-height)] whitespace-nowrap relative tracking-[var(--20-h2-letter-spacing)] [font-style:var(--20-h2-font-style)]">
          適用範圍
        </div>
        <img
          className="relative self-stretch w-full h-px object-cover"
          alt="Vector"
          src="/assets/images/privacy/vector-19-1.svg"
        />
        <div className="flex flex-col items-start gap-[8px]">
          <p className="self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-transparent text-[16px] leading-[24px] relative tracking-[0]">
            <span className="text-[#262831]">
              本《隱私權保護政策》適用於所有由本公司及其關係企業提供的服務，以及在第三方網站提供的服務
              (例如廣告服務)。我們打造的眾多服務每天可協助許多人以嶄新方式探索世界並與他人互動。這些服務包括：
              <br />
            </span>
          </p>
          <p className="self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-transparent text-[16px] leading-[24px] relative tracking-[0]">
            <span className="[font-family:'Noto_Sans_TC-Medium',Helvetica] font-bold text-[#224f49] underline">
              歐悅連鎖精品汽車旅館
              <br />
            </span>
          </p>
          <p className="self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-transparent text-[16px] leading-[24px] relative tracking-[0]">
            <span className="[font-family:'Noto_Sans_TC-Medium',Helvetica] font-bold text-[#224f49] underline">
              歐悅農牧整合
              <br />
            </span>
          </p>
          <p className="self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-transparent text-[16px] leading-[24px] relative tracking-[0]">
            <span className="[font-family:'Noto_Sans_TC-Medium',Helvetica] font-bold text-[#224f49] underline">
              歐悅金融科技
              <br />
            </span>
          </p>
          <p className="self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-transparent text-[16px] leading-[24px] relative tracking-[0]">
            <span className="[font-family:'Noto_Sans_TC-Medium',Helvetica] font-bold text-[#224f49] underline">
              歐悅能源
              <br />
            </span>
          </p>
          <p className="self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-transparent text-[16px] leading-[24px] relative tracking-[0]">
            <span className="[font-family:'Noto_Sans_TC-Medium',Helvetica] font-bold text-[#224f49] underline">
              歐悅建設開發
              <br />
            </span>
          </p>
          <p className="self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-transparent text-[16px] leading-[24px] relative tracking-[0]">
            <span className="text-[#262831]">
              透過我們的服務，您能夠以多種方式管理您的隱私權設定。舉例來說，只要申請本公司及其關係企業會員，您就可以建立及管理相關服務內容。即使您登出了帳戶或是從未申請帳戶，仍可以使用許多本公司及其關係企業的服務。
            </span>
          </p>
        </div>
      </div>
      <div className="flex-col max-w-[1036px] items-start gap-[16px] flex relative flex-[0_0_auto]">
        <div className="w-fit mt-[-1.00px] font-20-h2 font-[number:var(--20-h2-font-weight)] text-primaryprimary text-[length:var(--20-h2-font-size)] leading-[var(--20-h2-line-height)] whitespace-nowrap relative tracking-[var(--20-h2-letter-spacing)] [font-style:var(--20-h2-font-style)]">
          資料之蒐集
        </div>
        <img
          className="relative self-stretch w-full h-px object-cover"
          alt="Vector"
          src="/assets/images/privacy/vector-19-1.svg"
        />
        <div className="flex flex-col items-start gap-[8px]">
          <p className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
            <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
              我們收集資訊是為了向所有使用者提供更優質的服務；這些資訊可協助我們判斷基本設定
              (例如您使用的語言)，甚至分析較複雜的內容為了提供更良好的使用者體驗。本公司及其關係企業可能會請您提供姓名、身分證字號、地址、電話、E-mail、付款資訊或其他相關資料。除此之外，本公司及其關係企業也會保留您在本網站瀏覽或查詢時，伺服器自行產生的相關紀錄
              (包括但不限於您使用連線設備的 IP
              位址、瀏覽行為、使用的瀏覽器、使用時間、瀏覽及點選資料紀錄等)。除法規要求更長的保留期間外，本公司及其關係企業僅於本隱私權保護政策所述目的之必要期間內保留您的個人資料。您不一定要依照本公司及其關係企業的要求提供個人資料，若您未能提供相關個人資料時，將可能導致本公司及其關係企業在許多情況下無法為您提供產品或完善的服務，或是無法回應您提出的問題。
              <br />
            </span>
          </p>
          <ul className={`${styles['cust-ul']}`}>
            <li className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
              <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
                如果您未登入本公司及其關係企業帳戶，我們會運用您使用的瀏覽器、應用程式或裝置所連結的唯一識別碼來儲存我們所蒐集的資訊。這樣一來，我們就能在所有瀏覽工作階段中保留您的偏好設定，例如偏好語言，或者是否要根據您的活動顯示更相關的搜尋結果或廣告。
                <br />
              </span>
            </li>
            <li className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
              <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
                如果您登入了本公司及其關係企業帳戶，我們會另外收集本公司及其關係企業帳戶中儲存的資訊，並將它們視為個人資料處理。
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div className="flex-col max-w-[1036px] items-start gap-[16px] flex relative flex-[0_0_auto]">
        <div className="w-fit mt-[-1.00px] font-20-h2 font-[number:var(--20-h2-font-weight)] text-primaryprimary text-[length:var(--20-h2-font-size)] leading-[var(--20-h2-line-height)] whitespace-nowrap relative tracking-[var(--20-h2-letter-spacing)] [font-style:var(--20-h2-font-style)]">
          資料之運用
        </div>
        <img
          className="relative self-stretch w-full h-px object-cover"
          alt="Vector"
          src="/assets/images/privacy/vector-19-1.svg"
        />
        <div className="flex flex-col items-start gap-[8px]">
          <p className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
            <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
              本公司及其關係企業所蒐集的個人資料，將依其蒐集時所闡述之特定目的使用；本公司及其關係企業所蒐集個人資料之使用目的、利用對象、時間等資訊請參考相關網頁之內容，本公司及其關係企業不會為超出蒐集目的外之用途。以下舉例說明使用方式：
              <br />
            </span>
          </p>
          <ul className={`${styles['cust-ul']}`}>
            <li className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
              <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
                本公司及其關係企業所蒐集的個人資料可通知您本公司及其關係企業最新的軟體更新和即將舉行的活動，若您不希望列載於本公司及其關係企業的郵寄列表，您可隨時更改偏好設定。
                <br />
              </span>
            </li>
            <li className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
              <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
                本公司及其關係企業可能會使用個人資料來製作、開發、操作、提供並改善本公司及其關係企業之服務及廣告，或是基於避免損害發生及反詐騙目的而使用個人資料。
                <br />
              </span>
            </li>
            <li className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
              <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
                本公司及其關係企業可能會使用包括您生日在內的個人資料來驗證身分、協助辨識使用者及確認適當的服務。
                <br />
              </span>
            </li>
            <li className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
              <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
                本公司及其關係企業可能不定時使用個人資料以寄送重要通知，例如政策變更的通知。由於本項通知訊息對您與本公司及其關係企業的互動十分重要，您無法取消接收本項通知。
                <br />
              </span>
            </li>
            <li className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
              <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
                本公司及其關係企業可能基於內部及/或外部目的而使用個人資料，例如：資料分析及研究或與外部單位進行產學合作，以改進本公司及其關係企業之服務。若您為參加抽獎、競賽或各類線上活動而提供個人資料，本公司及其關係企業將會視蒐集目的做為答覆問題或抽獎結果通知、商業及市場分析等用途。本公司及其關係企業如需對外公佈抽獎結果皆會予以遮蔽，以保護您的個人資料安全。
                <br />
              </span>
            </li>
          </ul>
          <p className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
            <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
              本公司及其關係企業也會蒐集無法直接或間接識別與任何特定個人的資料。以下舉例說明使用方式：
              <br />
            </span>
          </p>
          <ul className={`${styles['cust-ul']}`}>
            <li className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
              <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
                本公司及其關係企業可能蒐集職業、語言、郵遞區號、區域號碼、唯一裝置識別碼、推薦連結網站、地點等資訊，協助本公司及其關係企業更深入瞭解您的行為，改善本公司及其關係企業之服務及廣告。
                <br />
              </span>
            </li>
            <li className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
              <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
                本公司及其關係企業可能蒐集您在使用本公司及其關係企業網站及服務時的活動相關資訊。本公司及其關係企業將彙總這類資訊，以提供您更實用的資訊，並分析本公司及其關係企業網站及服務關注度。
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div className="flex-col max-w-[1036px] items-start gap-[16px] flex relative flex-[0_0_auto]">
        <div className="relative w-fit mt-[-1.00px] font-20-h2 font-[number:var(--20-h2-font-weight)] text-primaryprimary text-[length:var(--20-h2-font-size)] tracking-[var(--20-h2-letter-spacing)] leading-[var(--20-h2-line-height)] whitespace-nowrap [font-style:var(--20-h2-font-style)]">
          Cookie 政策
        </div>
        <img
          className="relative self-stretch w-full h-px object-cover"
          alt="Vector"
          src="/assets/images/privacy/vector-19-1.svg"
        />
        <div className="flex flex-col items-start gap-[8px]">
          <p className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
            <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
              為了提供您更好、更個人化的服務、方便您參與個人化的互動活動，以及本公司及其關係企業為瞭解及管理本網站使用情形
              (包括但不限於分析訪客人數、網站流量、使用者分布、產品/服務關注度、活動行為及使用模式)、提昇本網站服務品質、提供符合您需求或興趣偏好之客製化行銷資訊或廣告並追蹤其成效等類似目的，本公司及其關係企業將自行或透過合作廠商運用
              Cookies、第三方數據埋點工具或其他類似技術之工具 (以下合稱標記工具)
              來記錄、存取及蒐集您的線上行為資料。
              <br />
            </span>
          </p>
          <p className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
            <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
              如果瀏覽器、安裝的程式或裝置允許，您可隨時阻止、刪除或停用標記工具
              (瀏覽器設定請參考下方說明)，例如在瀏覽器設定中選擇修改對 Cookies
              的接受程度，包括接受所有 Cookies、設定 Cookies
              時得到通知、拒絕所有 Cookies
              等三種。惟如果您選擇拒絕所有的標記工具，您可能無法使用部分個人化服務，或是參與部分活動。
              <br />
            </span>
          </p>
          <p className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
            <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
              線上行為資料包括當您訪問本網站、其他網站及社群媒體平台
              (不論是否與本網站相連結者) 所為網路行為而產生之資訊 (包括但不限於
              IP 位址、Cookie ID
              與其內容、唯一識別碼、網域名稱、裝置資訊、使用時間、瀏覽器類型、語言設定、地理位置、作業系統、伺服器紀錄、網頁搜尋/瀏覽/點選紀錄及使用模式與資訊或經合作廠商以其名義取得前開資料分析歸納而成標籤等類似資料)。
              <br />
            </span>
          </p>
          <p className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
            <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
              前述線上行為資料，將於前開目的存續期間內供本公司及其關係企業及因前開目的作業需要所委託處理之第三方或合作廠商，採自動化或非自動化之方式於國內外進行蒐集、處理、國際傳輸及利用，但未經您同意前，僅得於其國內外所在地進行不具可識別個人資料之蒐集、處理、國際傳輸及利用。
            </span>
          </p>
        </div>
        <div className="items-center justify-center gap-[10px] p-[16px] self-stretch w-full bg-[#DDF0EE] rounded-[8px] flex relative flex-[0_0_auto]">
          <div className="flex-1 mt-[-1.00px] font-normal text-[color:var(--neutralneutral-900)] text-[16px] leading-[24px] relative [font-family:'Noto_Sans_TC',_Helvetica] tracking-[0]">
            提醒您：當您訪問或瀏覽使用其他網站與社群平台時，該網站可能蒐集您的資料，您將受其他網站各自的隱私權保護政策拘束，本公司及其關係企業不對其他網站行為負責。
          </div>
        </div>
        <div className="flex flex-col items-start gap-[8px]">
          <p className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
            <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
              若需變更 Cookie 設定，請參考各瀏覽器的官方說明：
              <br />
            </span>
          </p>
          <p className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
            <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
              本公司及其關係企業網站設計上的功能，在啟用 Cookies
              時運作狀況最佳。但若您希望停用 Cookies，可透過瀏覽器設定進行控制。
              <br />
            </span>
          </p>
          <ul className={styles['cust-ul']}>
            <li className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
              <a
                href="https://support.google.com/accounts/answer/32050?hl=zh-Hant"
                rel="noopener noreferrer"
                target="_blank"
              >
                <span className="underline">
                  Google Chrome
                  <br />
                </span>
              </a>
            </li>
            <li className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
              <a
                href="https://support.apple.com/zh-tw/guide/safari/sfri11471/mac"
                rel="noopener noreferrer"
                target="_blank"
              >
                <span className="underline">
                  Apple Safari
                  <br />
                </span>
              </a>
            </li>
            <li className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
              <a
                href="https://support.microsoft.com/zh-tw/microsoft-edge/%E5%9C%A8-microsoft-edge-%E4%B8%AD%E5%88%AA%E9%99%A4-cookie-63947406-40ac-c3b8-57b9-2a946a29ae09"
                rel="noopener noreferrer"
                target="_blank"
              >
                <span className="underline">
                  Microsoft Edge
                  <br />
                </span>
              </a>
            </li>
            <li className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
              <a
                href="https://support.mozilla.org/zh-TW/kb/delete-cookies-remove-info-websites-stored"
                rel="noopener noreferrer"
                target="_blank"
              >
                <span className="underline">Mozilla Firefox</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="flex-col max-w-[1036px] items-start gap-[16px] flex relative flex-[0_0_auto]">
        <div className="w-fit mt-[-1.00px] font-20-h2 font-[number:var(--20-h2-font-weight)] text-primaryprimary text-[length:var(--20-h2-font-size)] leading-[var(--20-h2-line-height)] whitespace-nowrap relative tracking-[var(--20-h2-letter-spacing)] [font-style:var(--20-h2-font-style)]">
          商業活動資訊
        </div>
        <img
          className="relative self-stretch w-full h-px object-cover"
          alt="Vector"
          src="/assets/images/privacy/vector-19-1.svg"
        />
        <div className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
          為了增加整體服務內容，本網站所傳送的內容可能包括非本公司及其關係企業所提供的服務或其他優惠活動訊息，本公司及其關係企業將會在活動時提供充分說明，您可以自由選擇是否接受這項特定服務或活動。當您瀏覽相關活動訊息時，在未徵得同意前，本公司及其關係企業保證不會將您在本網站或本公司及其關係企業所登錄的任何個人資料轉送給第三方。本網站並將於事前或註冊登錄取得您的同意後，傳送商業性資料或電子郵件給您，本公司及其關係企業除了會在該資料或電子郵件上註明發送者，也會在該資料或電子郵件上提供您能隨時停止接收這些資料或電子郵件的方法、說明或功能連結。
        </div>
      </div>
      <div className="flex-col max-w-[1036px] items-start gap-[16px] flex relative flex-[0_0_auto]">
        <div className="w-fit mt-[-1.00px] font-20-h2 font-[number:var(--20-h2-font-weight)] text-primaryprimary text-[length:var(--20-h2-font-size)] leading-[var(--20-h2-line-height)] whitespace-nowrap relative tracking-[var(--20-h2-letter-spacing)] [font-style:var(--20-h2-font-style)]">
          第三方揭露
        </div>
        <img
          className="relative self-stretch w-full h-px object-cover"
          alt="Vector"
          src="/assets/images/privacy/vector-19-1.svg"
        />
        <p className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
          <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
            本公司及其關係企業會在您同意之情況下，將特定的個人資料提供給與本公司及其關係企業合作供應產品及服務的第三方供應商，以進行資訊處理、提供服務以及執行相關問卷調查，但不包括第三方利用該個人資料進行商業行銷行為。此外，本公司及其關係企業將要求本公司及其關係企業之供應產品及服務的第三方供應商，遵守
          </span>
          <a
            href="https://law.moj.gov.tw/LawClass/LawAll.aspx?PCode=I0050021"
            rel="noopener noreferrer"
            target="_blank"
          >
            <span className="[font-family:'Noto_Sans_TC-Medium',Helvetica] font-bold underline">
              中華民國「個人資料保護法」
            </span>
          </a>
          <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
            、本公司及其關係企業隱私權保護政策及其他相關法令規定之規定。
          </span>
        </p>
      </div>
      <div className="flex-col max-w-[1036px] items-start gap-[16px] flex relative flex-[0_0_auto]">
        <div className="w-fit mt-[-1.00px] font-20-h2 font-[number:var(--20-h2-font-weight)] text-primaryprimary text-[length:var(--20-h2-font-size)] leading-[var(--20-h2-line-height)] whitespace-nowrap relative tracking-[var(--20-h2-letter-spacing)] [font-style:var(--20-h2-font-style)]">
          資訊安全
        </div>
        <img
          className="relative self-stretch w-full h-px object-cover"
          alt="Vector"
          src="/assets/images/privacy/vector-19-1.svg"
        />
        <div className="flex flex-col items-start gap-[8px]">
          <p className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
            <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
              我們致力為您提供妥善保護，防止他人未經授權存取、竄改、揭露或毀損本公司及其關係企業持有的個人資訊。我們採取的措施包括：
              <br />
            </span>
          </p>
          <ul className={styles['cust-ul']}>
            <li className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
              <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
                傳輸您的資料時採用加密技術，保障資料的私密性。
                <br />
              </span>
            </li>
            <li className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
              <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
                檢查我們的資訊收集、儲存及處理做法
                (包括實體安全性措施)，防止他人未經授權存取我們的系統。
                <br />
              </span>
            </li>
            <li className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
              <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
                我們僅允許本公司及其關係企業員工、承包商和代理商基於處理資訊之需要存取個人資訊，且相關人員均須遵守嚴格的契約保密義務，一旦未遵守義務便將受到懲戒或解約處分。
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div className="flex-col max-w-[1036px] items-start gap-[16px] flex relative flex-[0_0_auto]">
        <div className="w-fit mt-[-1.00px] font-20-h2 font-[number:var(--20-h2-font-weight)] text-primaryprimary text-[length:var(--20-h2-font-size)] leading-[var(--20-h2-line-height)] whitespace-nowrap relative tracking-[var(--20-h2-letter-spacing)] [font-style:var(--20-h2-font-style)]">
          自我保護
        </div>
        <img
          className="relative self-stretch w-full h-px object-cover"
          alt="Vector"
          src="/assets/images/privacy/vector-19-1.svg"
        />
        <p className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
          本公司及其關係企業非常重視您個人資料的安全性並善盡保護責任。本網站以
          SSL (Secure Socket Layer)
          加密技術來保護您所提供資訊的安全，避免在傳輸時被第三人截取。本公司及其關係企業致力於提供安全的資訊環境
          (包括但不限於建立防火牆、加密技術、使用者辨識系統 (例如密碼及個人帳號)
          及存取控制機制等)，以控制個人資料之存取。同時也請您妥善保管個人資料、CA
          (Certificate authority) 憑證或密碼，並提醒您不要將任何個人資料
          (尤其是密碼)提供給任何人或其他機構。於使用完本網站所提供的各項服務功能後，請您務必登出；如與他人共用同一部電腦或使用公共電腦，請您務必關閉瀏覽器視窗，以防止他人讀取您的個人資料或信件。
        </p>
      </div>
      <div className="flex-col max-w-[1036px] items-start gap-[16px] flex relative flex-[0_0_auto]">
        <div className="w-fit mt-[-1.00px] font-20-h2 font-[number:var(--20-h2-font-weight)] text-primaryprimary text-[length:var(--20-h2-font-size)] leading-[var(--20-h2-line-height)] whitespace-nowrap relative tracking-[var(--20-h2-letter-spacing)] [font-style:var(--20-h2-font-style)]">
          兒童及青少年保護
        </div>
        <img
          className="relative self-stretch w-full h-px object-cover"
          alt="Vector"
          src="/assets/images/privacy/vector-19-1.svg"
        />
        <p className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
          為保障兒童使用本網站各項服務之權益，本公司及其關係企業將採取額外預防措施來保護他們的隱私權和安全，未獲得經過驗證的父母或監護人之同意，本公司及其關係企業不會在知情情況下蒐集
          13 歲以下 (或相關司法管轄地規定的等同最低年齡)
          兒童之個人資料。兒童的父母或監護人得向本公司及其關係企業申請檢視、更正或刪除兒童之資料。
        </p>
      </div>
      <div className="flex-col max-w-[1036px] items-start gap-[16px] flex relative flex-[0_0_auto]">
        <div className="w-fit mt-[-1.00px] font-20-h2 font-[number:var(--20-h2-font-weight)] text-primaryprimary text-[length:var(--20-h2-font-size)] leading-[var(--20-h2-line-height)] whitespace-nowrap relative tracking-[var(--20-h2-letter-spacing)] [font-style:var(--20-h2-font-style)]">
          資料共享
        </div>
        <img
          className="relative self-stretch w-full h-px object-cover"
          alt="Vector"
          src="/assets/images/privacy/vector-19-1.svg"
        />
        <div className="flex flex-col items-start gap-[8px]">
          <p className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
            <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
              本公司及其關係企業在取得客戶同意後，在符合法令規範之情形下，得為
              <br />
            </span>
          </p>
          <ul className={styles['cust-ul']}>
            <li className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
              <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
                辨識風險、進行風險控管
                <br />
              </span>
            </li>
            <li className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
              <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
                減少客戶重複輸入資料等便利客戶作業或為合作辦理業務
                <br />
              </span>
            </li>
          </ul>
          <p className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
            <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
              之目的共享資料。
            </span>
          </p>
        </div>
      </div>
      <div className="flex-col max-w-[1036px] items-start gap-[16px] flex relative flex-[0_0_auto]">
        <div className="w-fit mt-[-1.00px] font-20-h2 font-[number:var(--20-h2-font-weight)] text-primaryprimary text-[length:var(--20-h2-font-size)] leading-[var(--20-h2-line-height)] whitespace-nowrap relative tracking-[var(--20-h2-letter-spacing)] [font-style:var(--20-h2-font-style)]">
          權益行使
        </div>
        <img
          className="relative self-stretch w-full h-px object-cover"
          alt="Vector"
          src="/assets/images/privacy/vector-19-1.svg"
        />
        <div className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
          本公司及其關係企業讓您輕鬆維持正確、完整且最新的個人資料，您可至本公司及其關係企業查詢、請求閱覽、製給複製本、更正、補充、停止蒐集、處理、利用或刪除您的個人資料，惟本公司及其關係企業依法令規定或因執行業務所必須，得不依您的請求處理。
        </div>
      </div>
      <div className="flex-col max-w-[1036px] items-start gap-[16px] flex relative flex-[0_0_auto]">
        <div className="w-fit mt-[-1.00px] font-20-h2 font-[number:var(--20-h2-font-weight)] text-primaryprimary text-[length:var(--20-h2-font-size)] leading-[var(--20-h2-line-height)] whitespace-nowrap relative tracking-[var(--20-h2-letter-spacing)] [font-style:var(--20-h2-font-style)]">
          保護承諾
        </div>
        <img
          className="relative self-stretch w-full h-px object-cover"
          alt="Vector"
          src="/assets/images/privacy/vector-19-1.svg"
        />
        <div className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
          為了確保您的個人資料安全無虞，本公司及其關係企業已向內部員工傳達上述隱私權及安全準則，並在本公司及其關係企業內部嚴格執行隱私權防護措施。
        </div>
      </div>
      <div className="flex-col max-w-[1036px] items-start gap-[16px] flex relative flex-[0_0_auto]">
        <div className="w-fit mt-[-1.00px] font-20-h2 font-[number:var(--20-h2-font-weight)] text-primaryprimary text-[length:var(--20-h2-font-size)] leading-[var(--20-h2-line-height)] whitespace-nowrap relative tracking-[var(--20-h2-letter-spacing)] [font-style:var(--20-h2-font-style)]">
          資料移轉
        </div>
        <img
          className="relative self-stretch w-full h-px object-cover"
          alt="Vector"
          src="/assets/images/privacy/vector-19-1.svg"
        />
        <div className="flex flex-col items-start gap-[8px]">
          <p className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
            <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
              我們維護的伺服器遍布全球各地，因此您的資訊可能會由您所在國家/地區外的伺服器處理。每個國家/地區各有不同的資料保護法，保護的完善與嚴密程度也各不相同。無論我們是在哪裡處理您的資訊，一律會採用本政策中載明的保護措施。我們也會遵守與資料移轉相關的特定法律架構。
              <br />
            </span>
          </p>
          <p className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
            <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
              我們收到正式的書面申訴後，將與申訴人聯絡。我們會與適當的主管機關
              (包括當地的資料保護主管機關)
              合作，解決任何與您的資料移轉有關且無法由我們直接與您解決的申訴。
            </span>
          </p>
        </div>
      </div>
      <div className="flex-col max-w-[1036px] items-start gap-[16px] flex relative flex-[0_0_auto]">
        <div className="w-fit mt-[-1.00px] font-20-h2 font-[number:var(--20-h2-font-weight)] text-primaryprimary text-[length:var(--20-h2-font-size)] leading-[var(--20-h2-line-height)] whitespace-nowrap relative tracking-[var(--20-h2-letter-spacing)] [font-style:var(--20-h2-font-style)]">
          政策變更
        </div>
        <img
          className="relative self-stretch w-full h-px object-cover"
          alt="Vector"
          src="/assets/images/privacy/vector-19-1.svg"
        />
        <div className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
          本公司及其關係企業為保護使用者個人資料、維護網路隱私，將配合法令變動與因應最新技術，隨時更新本網站所提供的隱私權保護政策，以落實保障您的隱私權。我們會不時修訂本《隱私權保護政策》。我們不會在未取得您明確同意的情況下，逕自縮減本《隱私權保護政策》賦予您的權利。我們一定會標明最後修訂日期，建議您於再次來訪時，可重新瞭解本公司及其關係企業的最新隱私權保護政策及其改變。
        </div>
      </div>
      <div className="flex-col max-w-[1036px] items-start gap-[16px] flex relative flex-[0_0_auto]">
        <div className="w-fit mt-[-1.00px] font-20-h2 font-[number:var(--20-h2-font-weight)] text-primaryprimary text-[length:var(--20-h2-font-size)] leading-[var(--20-h2-line-height)] whitespace-nowrap relative tracking-[var(--20-h2-letter-spacing)] [font-style:var(--20-h2-font-style)]">
          聯絡資訊
        </div>
        <img
          className="relative self-stretch w-full h-px object-cover"
          alt="Vector"
          src="/assets/images/privacy/vector-19-1.svg"
        />
        <div className="flex flex-col items-start gap-[8px]">
          <p className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
            <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
              如您對於本隱私權保護政策或個人資料運用相關事項有任何疑問時，歡迎洽詢下述聯絡方式：
              <br />
            </span>
          </p>
          {isHotel ? (
            <p className="relative self-stretch [font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[color:var(--neutralneutral-900)] text-[16px] tracking-[0] leading-[24px]">
              <span className="[font-family:'Noto_Sans_TC',_Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
                公司電話：02 - 2609 - 0115
                <br />
                公司信箱：
                <a href="mailto:service@ohyamotel.com">service@ohyamotel.com</a>
                <br />
                公司地址：新北市林口區文化三路二段 115 巷 163 號 2 樓
              </span>
            </p>
          ) : (
            children
          )}
        </div>
      </div>
    </div>
  );
};
